import { render, staticRenderFns } from "./ReferenceModelView.vue?vue&type=template&id=c0f451d6&"
import script from "./ReferenceModelView.vue?vue&type=script&lang=js&"
export * from "./ReferenceModelView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports